<template>
  <div>
    <v-stepper v-model="step" class="elevation-0 transparent">
      <v-stepper-items>
        <!-- Step select site -->
        <v-stepper-content :step="1" class="pa-0" v-if="!hide">
          <v-card class="mb-4  tw-border">
            <v-container>
              <span class="sr-title">
                {{ $t("manager.websites.title") }}
              </span>

              <v-select
                  v-model="website"
                  :items="websitesWrapper"
                  :label="$t('manager.websites.list')"
                  item-text="host"
                  item-value="id"
              />
            </v-container>
          </v-card>
        </v-stepper-content>
        <!-- Step slot -->
        <v-stepper-content :step="2" class="pa-0">
          <v-card class="mb-4 tw-border" v-if="website !== null && websiteObject && !hide">
            <v-container>
              <span class="sr-title">
                {{ $t("manager.websites.selected") }}
              </span>

              <v-text-field v-model="websiteObject.host" readonly>
                <template #prepend>
                  <v-btn @click="back" color="primary" small>&leftarrow;</v-btn>
                </template>
              </v-text-field>
            </v-container>
          </v-card>

          <slot></slot>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import {Types as TypesSnackbar} from "@/store/modules/snackbar"

export default {
  name: "WebsiteWrapper",
  props: {
    hide: {type: Boolean, default: false},
    plan: {type: Number, default: -1},
    verified: {type: Number, default: 2},
    mandatory: {type: Boolean, default: false},
  },
  data: () => ({
    step: 1,
    websitesWrapper: [],
    website: null,
    websiteObject: null,
  }),
  mounted() {
    this.fetchWebsitesWrapper()
  },
  watch: {
    website(id) {
      this.select(id)
    },
  },
  methods: {
    fetchWebsitesWrapper() {
      const query = [`plan=${encodeURIComponent(this.plan)}`, `verified=${encodeURIComponent(this.verified)}`].join("&")

      this.$axios
          .get(`office/manager/websites/list?${query}`)
          .then(response => {
            this.websitesWrapper = response.data
            if (this.mandatory && this.websitesWrapper.length > 0 && this.websitesWrapper[0].hasOwnProperty("id")) {
              this.website = this.websitesWrapper[0].id
            }
          })
          .catch(() => this.handleError("manager.websites.error.fetch_websites"))
    },
    handleError(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: {timeout: 1000 * 6, color: "error"},
      })
    },
    select(id) {
      if (this.websitesWrapper.some(website => website.id === id)) {
        this.websiteObject = this.websitesWrapper.find(website => website.id === id)
      } else {
        this.websiteObject = null
      }

      if (this.websiteObject !== null) {
        this.step = 2
        this.$emit("selected", this.websiteObject)
      }
    },
    back() {
      this.website = null
      this.websiteObject = null
      this.step = 1
      this.$emit("back")
    },
  },
}
</script>
